import { Observable } from 'rxjs/internal/Observable';
import { ParkingSpace } from './models/parking-space.model';

export abstract class ParkingSpacesBase {
  abstract fetchParkingSpacesOfPL(
    parkingLotID: number,
    amountOfRetries: number
  ): Observable<Array<ParkingSpace>>;
}
